import Dexie, { Table } from "dexie";
import { DraftDocument } from "src/app/backend/models/draft-document";
import { Session } from "src/app/backend/models/session";

export class AppDB extends Dexie {
  sessions!: Table<Session, number>;
  draftDocuments!: Table<DraftDocument, string>;

  constructor() {
    super("snt-sessions");

    this.version(7).stores({
      sessions: "++id, memberId, domainName, accountNickName",
      draftDocuments: "id"
    });
  }
}

let db: AppDB;

export function getDatabase(): AppDB {
  if (!db) {
    db = new AppDB();
  }

  return db;
}
